import { useEffect, useRef, useState } from 'react'

export type CoachPhase = 'idle' | 'dots' | 'typing' | 'done'

export function useCoachTyping(text: string, skip?: boolean) {
  const [phase, setPhase] = useState<CoachPhase>(() => (skip && text ? 'done' : 'idle'))
  const [displayed, setDisplayed] = useState(() => (skip && text ? text : ''))
  const [iconKey, setIconKey] = useState(0)
  const cancelRef = useRef(false)

  useEffect(() => {
    cancelRef.current = false

    if (!text) {
      setPhase('idle')
      setDisplayed('')
      return () => {
        cancelRef.current = true
      }
    }

    if (skip) {
      setPhase('done')
      setDisplayed(text)
      return () => {
        cancelRef.current = true
      }
    }

    setDisplayed('')
    setPhase('dots')
    setIconKey((k) => k + 1)

    const indicatorTimer = setTimeout(() => {
      if (cancelRef.current) return
      setPhase('typing')
      let i = 0
      const typeNext = () => {
        if (cancelRef.current) return
        i++
        setDisplayed(text.slice(0, i))
        if (i < text.length) setTimeout(typeNext, 24)
        else setPhase('done')
      }
      typeNext()
    }, 650)

    return () => {
      cancelRef.current = true
      clearTimeout(indicatorTimer)
    }
  }, [text, skip])

  return { displayed, phase, iconKey }
}
